// /resources/js/app/modules/v2/apiClient.js
import axios from 'axios';

/**
 * Creates and configures a dedicated Axios instance for the V2 application.
 * This instance is specifically configured to send credentials (cookies) with
 * its requests, which is required for Sanctum authentication.
 *
 * Using a separate instance prevents conflicts with other parts of the site
 * that might rely on the global, un-configured axios instance from bootstrap.js.
 */
export const apiClient = axios.create({
    // This is the critical setting that ensures session cookies are sent.
    withCredentials: true,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    }
});